var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 125 100",
    viewBox: "0 0 125 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.12183 -3.7768)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.591 20.145 0.0106 58.723",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.606 20.104c-7.0627 2.8428-10.057 0.1001-9.6142 33.504",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.8597 53.695h9.6354",
    style: {
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.6754 -2.8626)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.56 37.476 18.042-0.12183",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.78 20.287 0.0106 58.723",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.31 20.287-0.11123 17.057",
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.38 20.287-0.11123 17.057",
    style: {
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60.185,
    cy: 46.54,
    r: 38.255,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.7,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.185,
    cy: 46.54,
    r: 25.985,
    fill: "none",
    stroke: "#EE7203",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.144,
    style: {
      paintOrder: "stroke fill markers"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.60e8d9f5244e8f0c89eba510fb858a06.svg";
export { ForwardRef as ReactComponent };